import React from "react";
import img1 from "../assets/images/sidom/fotos/misim/duotono/Recurso 1kickoff.png";
import img2 from "../assets/images/sidom/fotos/misim/duotono/Recurso 1kickoff-d.png";
import img3 from "../assets/images/sidom/fotos/misim/duotono/customization-d.png";
import img4 from "../assets/images/sidom/fotos/misim/duotono/customization.png";
import img5 from "../assets/images/sidom/fotos/misim/duotono/Servers-d.png";
import img6 from "../assets/images/sidom/fotos/misim/duotono/Servers.png";
import img7 from "../assets/images/sidom/fotos/misim/duotono/Recurso 7kickoff-d.png";
import img8 from "../assets/images/sidom/fotos/misim/duotono/Recurso 7kickoff.png";
import img9 from "../assets/images/sidom/fotos/misim/duotono/scalability-d.png";
import img10 from "../assets/images/sidom/fotos/misim/duotono/scalability.png";
import img11 from "../assets/images/sidom/fotos/misim/duotono/Recurso 5kickoff-d.png";
import img12 from "../assets/images/sidom/fotos/misim/duotono/Recurso 5kickoff.png";

const items = [
  {
    title: "100%SaaS",
    text: "SIDOM MiSIM es la única herramienta 100% SaaS Web del mercado con un modelo de inversión flexible",
    icon: img2,
    icon2: img1,
  },
  {
    title: "Customización",
    text: "Realizamos interfaces y desarrollos para automatizar los procesos a medida del cliente y sus necesidades sin costo",
    icon: img3,
    icon2: img4,
  },
  {
    title: "Estructura",
    text: "Granjas de servidores con kits maria alojados en el DATA CENTER más moderno y seguro de Argentina, 4x más rápidos gracias a nuestra conexión directa.",
    icon: img5,
    icon2: img6,
  },
  {
    title: "Automatización de procesos",
    text: "Mayor optimización y eficiencia de los procesos con la innovación tecnológica del único RPA nativo de Comercio Exterior",
    icon: img7,
    icon2: img8,
  },
  {
    title: "Escalabilidad",
    text: "Escalabilidad inmediata por disponer de todos los módulos desde el inicio de cada proyecto",
    icon: img9,
    icon2: img10,
  },
  {
    title: "Mejora Continua",
    text: "Al ser una solución cloud, la mejora es continua a partir de nuestro ADN innovador, el feedback de nuestra gran cantidad de clientes y cambios en el mercado.",
    icon: img11,
    icon2: img12,
  },
];

const BeneficiosDegradeBox = () => {
  return (
    <div className="  flex justify-center items-center bg-gradient-to-b from-sidom-orange from-80% to-sidom-blue ">
      <div className="container">
        <div className=" mt-[70px] md:mt-[100px] lg:mt-[90px] rounded-3xl shadow-lg p-8 bg-sidom-light dark:bg-sidom-blue transition-colors duration-300">
          <div className="grid grid-cols-1 md:grid-cols-2  gap-8">
            {items.map((item, idx) => (
              <div key={idx} className="flex  items-start gap-4 mb-4">
                <img
                  src={item.icon}
                  className="hidden dark:block w-12"
                  alt="Imagen modo oscuro"
                />
                <img
                  src={item.icon2}
                  className="block dark:hidden w-12"
                  alt="Imagen modo claro"
                />
                <div>
                  <div className="font-bold text-sidom-orange dark:text-sidom-light text-lg mb-1">
                    {item.title}
                  </div>
                  <div className="text-sidom-dark dark:text-sidom-light text-sm">
                    {item.text}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeneficiosDegradeBox;
